import PropTypes from 'prop-types';
import React from 'react';

export const RecentBookingsIcon = ({ color = '#000' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="13" fill="none">
    <g
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M14.072 1.35h5.714v5.714" />
      <path d="m19.786 1.35-8.072 8.072a.715.715 0 0 1-1 0L7.43 6.136a.714.714 0 0 0-1 0L1.214 11.35" />
    </g>
  </svg>
);

RecentBookingsIcon.propTypes = {
  color: PropTypes.string,
};
